
import { Component, ElementRef, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/auth/auth.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { BillingserviceService } from '../billingService.service';
import {  takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ServiceList } from '../Models/billing.Models';
import { SelectionModel } from '@angular/cdk/collections';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'app/shared/language.service';
@Component({
  selector: 'app-add-service',
  templateUrl: './add-service.component.html',
  styleUrls: ['./add-service.component.scss']
})
export class AddServiceComponent implements OnInit {
  destroyservice$: Subject<boolean> = new Subject<boolean>();
  private catselected = -1;
  private depselected = -1;
  private getRateType:number;
  private serviceQuery: string = '';
 // private  billentryid:number;
  // public ServiceArray:any =[]
  stype:any;
  @ViewChild('SeachButton') SearchButton: ElementRef;
  private todaysdate:any;
  displayedColumns: string[] = ['select','serviceName','categoryName','deptName','rate','maxDiscountLimit','serviceCharge','discount'];
  dataSource = new MatTableDataSource<ServiceList>();
  selection = new SelectionModel<ServiceList>(true, []);
  private  surgerydepartments_ds = new MatTableDataSource();
  private surgerycategories_ds = new MatTableDataSource();
  SelectedServiceArray:any =[];
  isAutomationMode: boolean = false;
  automationServices: string[] = [];
  automationServiceId: number | null = null;

   displayedColumns_surgerydepartments: string[] = ['surgeryDeptName'];
  displayedColumns_surgerycategories: string[] = ['surgeryCatName'];
  constructor(private dialog: MatDialog,
    private authService: AuthService,  private dashboardService: DashboardService,   private dialogRef: MatDialogRef<AddServiceComponent>,  @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private opdvisitService: OpdVisitService,private billingservice: BillingserviceService,private translate: TranslateService,private langservice: LanguageService) {
      translate.addLangs(['en', 'fr', 'hi']);
     if (this.langservice.setlang) {
       translate.setDefaultLang(this.langservice.setlang);
     }
     else {
       translate.setDefaultLang('en');
     }
     this.getDepartmentList();
     }
   

  ngOnInit(): void {
    this.todaysdate = this.authService.getServerDate;
    this.catselected = -1;
    this.getConfiglist();
    this.getRateType = parseInt(this.data.RateType);

    // Support both 'service' and 'serviceQuery' field names
    this.serviceQuery = (this.data?.service || this.data?.serviceQuery || '').toString().trim().toLowerCase();

    // Detect automation mode
    if (this.data?.automationServices && Array.isArray(this.data.automationServices) && this.data.automationServices.length > 0) {
      this.isAutomationMode = true;
      this.automationServices = this.data.automationServices.map((s: string) => s.toLowerCase().trim());
      console.log('AddService: Automation mode, services:', this.automationServices);
    } else if (this.serviceQuery) {
      this.isAutomationMode = true;
      this.automationServices = [this.serviceQuery];
      console.log('AddService: Single service automation mode:', this.serviceQuery);
    }

    // Direct serviceId from chatbot service picker (highest priority)
    if (this.data?.automationServiceId) {
      this.automationServiceId = Number(this.data.automationServiceId);
      this.isAutomationMode = true;
      console.log('AddService: Direct serviceId from chatbot picker:', this.automationServiceId);
    }

    // Use rateListId with fallback chain so it is never undefined
    const rateListId = (this.billingservice.ratelist && this.billingservice.ratelist.rateListId)
      ? this.billingservice.ratelist.rateListId
      : (this.billingservice.billserviceConfig?.fK_RatelistId || 1);

    // Load services: when chatbot picked a service by ID, search all categories so ID match works
    const categoryId = this.data?.automationServiceId ? 0 : (this.data?.Category_id || 0);
    console.log('AddService: Loading services – rateListId:', rateListId, 'categoryId:', categoryId);
    this.getServiceList(0, rateListId, categoryId);

    if (!this.isAutomationMode) {
      setTimeout(() => this.SearchButton.nativeElement.focus(), 300);
    }
  }
  indexvalue:number=-1;
  focusonrow(){
    this.indexvalue=0;
  }
  onRowFocus(index: number) {
    this.indexvalue = index;
  }
  ngOnDestroy() {
    this.destroyservice$.next(true);
    this.destroyservice$.unsubscribe();
    this.catselected=null;
    this.depselected=null;
    this.getRateType=null;
    this.todaysdate=null;
    this.displayedColumns=null;
    this.dataSource=null;
    this.selection=null;
    this.surgerydepartments_ds=null;
    this.surgerycategories_ds=null;
    this.SelectedServiceArray=null;
    this.displayedColumns_surgerydepartments=null;
    this.displayedColumns_surgerycategories=null;
    this.isAutomationMode=null;
    this.automationServices=null;
    this.automationServiceId=null;
  }
  
   getDepartmentList(){
   this.billingservice.getDepartmentList().pipe(takeUntil(this.destroyservice$)).subscribe(data =>this.successdepart(data), err =>this.failed_depart(err))
   }

   newdept:any=[];
   successdepart(data){
    this.surgerydepartments_ds.data=data;
    this.getCateogryList(data[0].deptId ,1);
   }
   failed_depart(err){
    if(err.status==403){
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }else{
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
   }

   getCateogryList(deptid,type){
   
    this.billingservice.getCateogryList(deptid).pipe(takeUntil(this.destroyservice$)).subscribe(data => this.successCategory(data,deptid,type), err => this.failed_category(err))
   }

   successCategory(data,deptid,type){
    this.surgerycategories_ds.data=[];
    this.surgerycategories_ds.data=data;
    var catid=data[0]?.categoryId?data[0]?.categoryId: 0;
    if(type ==0){
      this.depselected=deptid;
      this.catselected=catid;
      this.getServiceList(deptid,this.billingservice.ratelist.rateListId,catid);
    }
   
   }
   failed_category(err){
    if(err.status==403){
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }else{
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
   }
     //get rate list 
  getServiceList(DepartId:any,ratelist,catid:any){
   
     let CategoryId=catid;
     let RateListId=ratelist;
     let RateTypeId= this.getRateType;
     let DepartmentId=DepartId;
    this.billingservice.getserviceByDepartmentId(DepartmentId,CategoryId,RateListId,RateTypeId).pipe(takeUntil(this.destroyservice$)).subscribe((data: any[])=>{
     this.billingservice.servicelist=[];
      this.billingservice.servicelist = data;

        // Clear previous selection when loading a new department/category
        this.selection.clear();
        this.SelectedServiceArray = [];

        this.dataSource.data=this.billingservice.servicelist;

        // Only attempt auto-selection when explicitly in automation mode
        if (this.isAutomationMode) {
          this.tryAutoSelectService();
        }
     
   
    },err=>{
      if(err.status==403){
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }else{
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  private tryAutoSelectService(): void {
    const list = this.billingservice.servicelist;

    // Fast path: direct ID match from chatbot service picker
    if (this.automationServiceId && list?.length) {
      const byId = list.find((s: any) =>
        s.serviceId === this.automationServiceId
        || s.rateListDetailId === this.automationServiceId
        || s.fK_ServiceId === this.automationServiceId
      );
      if (byId) {
        console.log('AddService: Direct ID match → "' + byId.serviceName + '" (id=' + this.automationServiceId + ')');
        this.applyAndClose([byId]);
        return;
      }
      console.log('AddService: serviceId ' + this.automationServiceId + ' not in loaded list, falling back to name match');
    }

    if (!this.automationServices?.length) {
      console.log('AddService: No automation services configured');
      return;
    }

    console.log('AddService: Matching [' + this.automationServices.join(', ') + '] against '
      + (list?.length || 0) + ' services');

    const matched: any[] = [];
    const unmatched: string[] = [];

    for (const query of this.automationServices) {
      const found = list?.length ? this.findServiceByName(query, list) : null;
      if (found && !matched.some((s: any) => s.serviceId === found.serviceId)) {
        matched.push(found);
        console.log('AddService: Matched "' + query + '" → "' + found.serviceName + '"');
      } else if (!found) {
        unmatched.push(query);
        if (list?.length) {
          console.warn('AddService: No client-side match for "' + query + '". Top 10 available: ['
            + list.slice(0, 10).map((s: any) => s.serviceName).join(' | ') + ']');
        }
      }
    }

    if (matched.length > 0) {
      this.applyAndClose(matched);
    } else if (unmatched.length > 0) {
      // Fallback: server-side search using the existing search API (searches by partial service name)
      this.serverSearchAndSelect(unmatched[0]);
    }
  }

  private applyAndClose(services: any[]): void {
    services.forEach((service: any) => {
      this.selection.select(service);
      if (!this.SelectedServiceArray.some((item: any) => item.serviceId === service.serviceId)) {
        this.SelectedServiceArray.push(service);
      }
    });
    this.billingservice.selectedServiceRow = this.SelectedServiceArray;
    console.log('AddService: Auto-selecting ' + this.SelectedServiceArray.length + ' service(s): '
      + this.SelectedServiceArray.map((s: any) => s.serviceName).join(', '));
    setTimeout(() => this.dialogRef.close(), 150);
  }

  private serverSearchAndSelect(query: string): void {
    const rateListId = (this.billingservice.ratelist && this.billingservice.ratelist.rateListId)
      ? this.billingservice.ratelist.rateListId
      : (this.billingservice.billserviceConfig?.fK_RatelistId || 1);
    const rateTypeId = this.getRateType || 1;
    const q = query.trim();

    console.log('AddService: Server search for "' + q + '"');

    this.billingservice.getserviceByDepartmentIdByCatByService(
      rateListId, rateTypeId, '~', '~', q, 'S'
    ).pipe(takeUntil(this.destroyservice$)).subscribe(
      (data: any[]) => {
        console.log('AddService: Server returned ' + (data?.length || 0) + ' result(s) for "' + q + '"');
        if (data && data.length > 0) {
          const best = this.findServiceByName(q, data) || data[0];
          console.log('AddService: Server match "' + q + '" → "' + best.serviceName + '"');
          this.applyAndClose([best]);
        } else {
          // Server found nothing (e.g. "bsscan" doesn't LIKE-match "B-SCAN").
          // Load ALL services across all categories and run fuzzy client-side match —
          // findServiceByName uses editDistance so "bsscan" → "B-SCAN" (distance=1) works.
          this.loadAllAndMatch(q, rateListId, rateTypeId);
        }
      },
      () => this.loadAllAndMatch(q, rateListId, rateTypeId)
    );
  }

  private loadAllAndMatch(query: string, rateListId: number, rateTypeId: number): void {
    console.log('AddService: Loading ALL services for broad fuzzy match of "' + query + '"');
    this.billingservice.getserviceByDepartmentId(0, 0, rateListId, rateTypeId)
      .pipe(takeUntil(this.destroyservice$)).subscribe(
      (all: any[]) => {
        console.log('AddService: All-services list size: ' + (all?.length || 0));
        if (all && all.length > 0) {
          const best = this.findServiceByName(query, all);
          if (best) {
            console.log('AddService: Broad match "' + query + '" → "' + best.serviceName + '"');
            this.applyAndClose([best]);
          } else {
            this.showNotFound();
          }
        } else {
          this.showNotFound();
        }
      },
      () => this.showNotFound()
    );
  }

  private showNotFound(): void {
    const label = this.automationServices?.join(', ') || '';
    console.warn('AddService: "' + label + '" not found in any search pass');
    this.dataSource.filter = (this.automationServices?.[0] || '').trim().toLowerCase();
    this.dashboardService.openSnackBar(
      'Service "' + label + '" not found. Please select from the list.',
      'OK'
    );
  }

  // Name matching with text normalization (removes hyphens/dots/parens) and stem matching.
  // "consulting" matches "CONSULTATION" because both share 5-char stem "consu".
  private findServiceByName(query: string, list: any[]): any | null {
    // Normalize: lowercase, replace punctuation with space, collapse spaces
    const norm = (s: string): string =>
      (s || '').toLowerCase()
        .replace(/[.\-\/()&,;:]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    const q = norm(query);
    if (!q || q.length < 2) return null;

    const qWords = q.split(' ').filter(w => w.length > 0);

    // Two words share a stem if their first minLen chars are identical
    const sameStem = (a: string, b: string, minLen: number): boolean => {
      const len = Math.min(a.length, b.length);
      return len >= minLen && a.slice(0, minLen) === b.slice(0, minLen);
    };

    // Word-level match: exact, prefix (both directions), or 5-char stem
    const wordMatch = (qw: string, nw: string): boolean =>
      nw === qw ||
      (nw.startsWith(qw) && qw.length >= 3) ||    // "lab" → "laboratory"
      (qw.startsWith(nw) && nw.length >= 3) ||     // "laboratories" contains "laborator"
      sameStem(qw, nw, 5);                          // "consulting" ↔ "consultation"

    let best: any = null;
    let bestScore = 0;

    for (const item of list) {
      const name = norm(item.serviceName || '');
      if (!name) continue;

      let score = 0;

      // 1. Exact match (after normalization — handles ALL-CAPS, hyphens, extra spaces)
      if (name === q) return item;

      // 2. Normalized name contains full query (e.g. "consultation" inside "opd consultation")
      if (name.includes(q) && q.length >= 2) {
        score = 90;
      }
      // 3. Normalized query contains full service name (user typed extra words)
      else if (q.includes(name) && name.length >= 3) {
        score = 75;
      }
      else {
        // 4. Word-level matching with prefix + stem tolerance
        const nameWords = name.split(' ').filter(w => w.length > 0);
        if (qWords.length > 0) {
          const matchedCount = qWords.filter(qw =>
            nameWords.some(nw => wordMatch(qw, nw))
          ).length;
          const ratio = matchedCount / qWords.length;
          if (ratio >= 1)        score = 70;   // every query word matched
          else if (ratio >= 0.6) score = 50;   // majority matched
          else if (ratio >= 0.4) score = 35;   // some matched
        }

        // 5. Single edit-distance fallback (handles "xray" ↔ "x ray" = 1 space insertion)
        if (score < 30 && q.length >= 4 && this.editDistance(q, name) === 1) {
          score = 30;
        }
      }

      if (score > bestScore) {
        bestScore = score;
        best = item;
      }
    }

    return bestScore >= 30 ? best : null;
  }

  private editDistance(a: string, b: string): number {
    const m = a.length, n = b.length;
    if (Math.abs(m - n) > 4) return 99; // early exit for very different lengths
    const dp: number[][] = [];
    for (let i = 0; i <= m; i++) {
      dp[i] = [];
      for (let j = 0; j <= n; j++) {
        dp[i][j] = i === 0 ? j : j === 0 ? i : 0;
      }
    }
    for (let i = 1; i <= m; i++) {
      for (let j = 1; j <= n; j++) {
        dp[i][j] = a[i - 1] === b[j - 1]
          ? dp[i - 1][j - 1]
          : 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
      }
    }
    return dp[m][n];
  }
  getConfiglist() {
    
    let BranchId=this.authService.Loggeduser.branchid;
 
  this.dashboardService.subscriptions=  this.billingservice.get_Bill_Congigrationlist(BranchId).
      subscribe(data => this.success_config(data), err => this.failed_config(err));
  }
  success_config(data) {
    this.billingservice.billserviceConfig={};
    // console.log('billing confrigration',data);
    this.billingservice.billserviceConfig= data[0];
    for (let i = 0; i < this.billingservice.servicelist.length; i++) {
      const element = this.billingservice.servicelist[i];
      if(element.serviceId === data[0].fK_FollowupServiceId){
        this.billingservice.selectedServiceRow = this.billingservice.servicelist[i];
        // console.log('default selected service',this.billingservice.selectedServiceRow)
      }
      
    }
     

  }

  failed_config(err) {
    if(err.status==403){
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }else{
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
 }

 
  filtersurgerylist(row){ 
    
    let catid = row.categoryId;
    this.catselected = catid;
    var depatid=row.deptId;
    this.getServiceList(depatid,this.billingservice.ratelist.rateListId,this.catselected);
     }
    
    applyFilter_grid(filterValue){
      this.dataSource.filter = filterValue.trim().toLowerCase();

    }

   
    isAllSelected() {
       const numSelected = this.selection.selected.length;
      const numRows = this.dataSource.data.length;
      return numSelected === numRows;
    }
  
    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
      if (this.isAllSelected()) {
        this.selection.clear();
        this.SelectedServiceArray = [];
      } else {
        // Select all from current filtered data
        this.dataSource.data?.forEach(row => {
          this.selection.select(row);
          // Add to SelectedServiceArray if not already there
          const alreadyExists = this.SelectedServiceArray.some(item => 
            item.serviceId === row.serviceId
          );
          if (!alreadyExists) {
            this.SelectedServiceArray.push(row);
          }
        });
      }
      console.log('masterToggle: Selected services count:', this.SelectedServiceArray.length);
    }

    selectRow(row) {
      // Check if already selected
      const alreadySelected = this.SelectedServiceArray.some(item => 
        item.serviceId === row.serviceId
      );
      
      if (!alreadySelected) {
        // Add to selection
        this.selection.select(row);
        this.SelectedServiceArray.push(row);
      } else {
        // Remove from selection
        this.selection.deselect(row);
        this.SelectedServiceArray = this.SelectedServiceArray.filter(item => 
          item.serviceId !== row.serviceId
        );
      }
      
      // Remove duplicates based on serviceName and FK_ServiceId
      this.SelectedServiceArray = this.SelectedServiceArray.reduce((unique, o) => {
        if (!unique.some(obj => obj.serviceName === o.serviceName && (obj.serviceId === o.serviceId))) {
          unique.push(o);
        }
        return unique;
      }, []);
      
      console.log('selectRow: Selected services count:', this.SelectedServiceArray.length);
      console.log('selectRow: Selected array:', this.SelectedServiceArray.map(s => s.serviceName));
    }

    removeRow(x){
      const index: number = this.SelectedServiceArray.indexOf(x);
      if (index !== -1) {
        this.SelectedServiceArray.splice(index, 1);
        this.selection.toggle(x);
      }
      // this.SelectedServiceArray.splice(x, 1 );
      // this.dataSource.data= this.BillDetailArray;
      // this.paymentDetail(this.BillDetailArray);
   }

   saveServices(){
    console.log('saveServices: Saving', this.SelectedServiceArray.length, 'services');
    
    if (this.SelectedServiceArray.length === 0) {
      this.dashboardService.openSnackBar('Please select at least one service', 'OK');
      return;
    }
    
    this.billingservice.selectedServiceRow=this.SelectedServiceArray;
    console.log('saveServices: Saved services:', this.SelectedServiceArray.map(s => s.serviceName).join(', '));
    this.dialogRef.close();
   }
   closedialog(){
    this.dialogRef.close();
    this.billingservice.selectedServiceRow=[];
    this.SelectedServiceArray=[];
    }


   getrowdata(row:any){
   console.log('getrowdata: Double-click selecting service:', row.serviceName);
   
   // Check if already exists
   const alreadyExists = this.SelectedServiceArray.some(item => 
     item.serviceId === row.serviceId
   );
   
   if (!alreadyExists) {
     this.SelectedServiceArray.push(row);
     this.selection.select(row);
   }
   
   this.billingservice.selectedServiceRow=this.SelectedServiceArray;
   this.dashboardService.openSnackBar("Service selected. Click Done button to confirm.", "OK");
   console.log('getrowdata: Services in array:', this.SelectedServiceArray.map(s => s.serviceName).join(', '));
   this.indexvalue = -1;
    }

    addsurgery(){
      this.billingservice.selectedServiceRow=this.selection.selected;
      this.dialogRef.close();
     }
}
